<template>
  <div>
    <div class="animated fadeIn">
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" />
    </div>
    <b-card>
      <b-row>
        <b-col xl="6" md="6" sm="12">
          <span class="f-g">
            <h3 v-if="!haveItems">Você não possui promoções ativas</h3>
            <h3 v-if="haveItems">Você possui {{ numPromocoes }} promoções ativas</h3>
          </span>
        </b-col>
        <b-col xl="6" md="6" sm="12">
          <div>
            <b-button
              variant="success"
              class="my-2 my-sm-0 mr-sm-2 w100"
              type="submit"
              v-b-modal.modalAddPromocao
            >
              <i class="fa fa-plus fa-xl"></i>
              Adicionar promoção
            </b-button>
            <b-button
              variant="primary"
              class="my-2 my-sm-0 w100 mr5"
              type="submit"
              @click="atualizarJornalzinho"
            >
              <i class="fa fa-edit"></i>
              Jornalzinho
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-card class="text-center f-g" v-if="!haveItems">
      <i class="fa fa-frown-o fa-custom-size"></i>
      <h4>Desculpe, não encontramos nenhuma promoção :(</h4>
      <h5>Para iniciar, clique no botão acima e comece as integrações!</h5>
    </b-card>
    <b-card class="text-center mt-3" v-if="haveItems">
      <b-table
        :items="items"
        :fields="fields"
        striped
        bordered
        hover
        @row-clicked="rowHandler"
        class="mb-0"
      >
        <template slot="urlthumbnail" slot-scope="data">
          <img
            v-if="data.item.urlthumbnail"
            :src="data.item.urlthumbnail"
            alt="Thumbnail"
            style="height: 32px;"
          />
          <span v-else>Sem imagem</span>
        </template>
        <template slot="isdestaque" slot-scope="data">
          <i v-if="data.item.isjornalzinho == 1" class="fa fa-star fa-lg"></i>
          <i v-else-if="data.item.isdestaque == 1" class="fa fa-star fa-lg"></i>
          <i v-else class="fa fa-star-o fa-lg"></i>
        </template>
        <template slot="isjornalzinho" slot-scope="data">
          <i v-if="data.item.isjornalzinho == 1" class="fa fa-check fa-lg"></i>
          <i v-else class="fa fa-times fa-lg"></i>
        </template>
      </b-table>
    </b-card>
    <b-modal id="modalAddPromocao" centered title="Adicionar promoção">
      <span
        class="mx-auto text-center"
      >Para adicionar uma promoção, escolha uma das opções abaixo para continuar:</span>
      <div slot="modal-footer" class="w-100">
        <b-row>
          <b-col cols="12">
            <b-button
              class="m-w mb-10"
              variant="danger"
              @click="inserirPromocao"
            >Vincular com o sistema Accesys</b-button>
          </b-col>
          <b-col cols="12">
            <b-button class="m-w" disabled>Criar manualmente</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal ref="modalEditaPromocao" size="lg" centered hide-footer :title="titlePromocaoModal">
      <b-row>
        <b-col cols="4" @click="destacarProdutos">
          <b-col cols="12" class="centerModal">
            <i class="fa fa-star-o fa-custom-size" aria-hidden="true"></i>
            <span>
              Destacar
              <br />Produtos
            </span>
          </b-col>
        </b-col>
        <b-col cols="4" @click="editarImagem(urlImagemSelecionada)">
          <b-col cols="12" class="centerModal">
            <i class="fa fa-file-image-o fa-custom-size" aria-hidden="true"></i>
            <span v-if="!urlImagemSelecionada">
              Vincular
              <br />Imagem
            </span>
            <span v-if="urlImagemSelecionada">
              Editar
              <br />Imagem
            </span>
          </b-col>
        </b-col>
        <b-col cols="4" @click="reenviarCampanha(idPromocaoSelecionada)">
          <b-col cols="12" class="centerModal">
            <i class="fa fa-share-square-o fa-custom-size" aria-hidden="true"></i>
            <span>
              Reenviar
              <br />Campanha
            </span>
          </b-col>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="4" @click="editarPromocao(idPromocaoSelecionada)">
          <b-col cols="12" class="centerModal">
            <i class="fa fa-edit fa-custom-size" aria-hidden="true"></i>
            <span>
              Editar
              <br />promoção
            </span>
          </b-col>
        </b-col>
        <b-col cols="4" @click="desvincularPromocao(idPromocaoSelecionada)">
          <b-col cols="12" class="centerModal">
            <i class="fa fa-times fa-custom-size" aria-hidden="true"></i>
            <span>
              Desvincular
              <br />promoção
            </span>
          </b-col>
        </b-col>
        <b-col cols="4" @click="atualizarItensPromocao(idPromocaoSelecionada)">
          <b-col cols="12" class="centerModal">
            <i class="fa fa-refresh fa-custom-size" aria-hidden="true"></i>
            <span>
              Atualizar
              <br />itens
            </span>
          </b-col>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import axios from "axios";
import * as config from "@/config.json";

export default {
  name: "promocoes",
  components: {
    Loading
  },
  data: function() {
    return {
      titlePromocaoModal: "",
      idPromocaoSelecionada: null,
      urlImagemSelecionada: null,
      promocaoDestacada: null,
      isLoading: false,
      temPromocoes: false,
      numPromocoes: 0,
      items: [],
      fields: [
        { key: "urlthumbnail", label: "Imagem" },
        { key: "isdestaque", label: "Destaque" },
        "titulo",
        "descricao",
        { key: "data_inicial", label: "Início", sortable: true },
        { key: "data_final", label: "Fim", sortable: true },
        { key: "isjornalzinho", label: "Jornalzinho" }
      ],
      haveItems: false,
      IsJornalzinho: null,
      id_local: null,
      isdestaque: null
    };
  },
  methods: {
    inserirPromocao() {
      localStorage.setItem("jornalzinho", "0");
      this.$router.push("promocoes/inserir-promocao");
    },
    async destacaPromocao() {
      this.isLoading = true;
      await axios
        .post(
          `${config.default.servidor}/gerencial/promocao/completa/destaque`,
          {
            id: this.idPromocaoSelecionada,
            destaque: this.isdestaque ? 1 : 0
          },
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(async res => {
          if (res.status === 200) {
            await this.procurarPromocoes();
          } else {
            let toast = this.$toasted.show("Erro ao atualizar promoções.", {
              theme: "toasted-primary",
              position: "bottom-center",
              duration: 5000,
              icon: "times",
              iconPack: "fontawesome"
            });
          }
          this.$refs.modalEditaPromocao.hide();
        });
      this.isLoading = false;
    },
    destacarProdutos() {
      var currentVersion = parseInt(localStorage.getItem("app_version"));
      if (currentVersion === 13) this.destacaPromocao();
      else this.$router.push("promocoes/destaques");
    },
    atualizarJornalzinho() {
      localStorage.setItem("jornalzinho", "1");
      this.$router.push("promocoes/inserir-promocao");
    },
    reenviarCampanha(id) {
      localStorage.setItem("id", id);
      localStorage.setItem("isPromocao", "true");
      this.$router.push("reenviar-campanha");
    },
    rowHandler(record, index) {
      localStorage.setItem("promocaoSelecionada", JSON.stringify(record));
      this.id_local = record.id_local;
      this.titlePromocaoModal = `${record.titulo}`;
      this.idPromocaoSelecionada = record.id;
      this.urlImagemSelecionada = record.urlimagem;
      this.isdestaque = record.isdestaque;
      if (record.isdestaque == 1) {
        this.promocaoDestacada = true;
      } else {
        this.promocaoDestacada = false;
      }
      if (record.isjornalzinho == 1) {
        this.IsJornalzinho = true;
      } else {
        this.IsJornalzinho = false;
      }
      this.$refs.modalEditaPromocao.show();
    },
    async atualizarItensPromocao(id) {
      this.$refs.modalEditaPromocao.hide();
      this.isLoading = true;
      await axios
        .post(
          `${config.default.servidor}/gerencial/promocao/itens`,
          {
            empresaid: localStorage.getItem("enterprise_id"),
            promocaoid: this.id_local,
            promocaowebid: id
          },
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          const options = { title: "Aviso", size: "sm" };
          if (!response.data.error) {
            let toast = this.$toasted.show("Itens atualizados!", {
              theme: "toasted-primary",
              position: "bottom-center",
              duration: 5000,
              icon: "check",
              iconPack: "fontawesome"
            });
          } else {
            let toast = this.$toasted.show("Falha ao atualizar itens.", {
              theme: "toasted-primary",
              position: "bottom-center",
              duration: 5000,
              icon: "exclamation-triangle",
              iconPack: "fontawesome"
            });
          }
          this.isLoading = false;
        })
        .catch(error => {
          console.error(error);
        });
    },
    editarImagem(url) {
      localStorage.setItem("url_imagem", url);
      localStorage.setItem("titulo_promocao", this.titlePromocaoModal);
      localStorage.setItem("id_promocao", this.idPromocaoSelecionada);
      if (this.IsJornalzinho)
        this.$router.push({ path: "promocoes/editar-imagem-jornalzinho" });
      else this.$router.push({ path: "promocoes/editar-imagem" });
    },
    desvincularPromocao(id) {
      this.$refs.modalEditaPromocao.hide();
      const options = {
        title: "Desvincular promoção",
        cancelLabel: "Cancelar",
        okLabel: "Sim"
      };
      this.$dialogs
        .confirm("Confirma desvincular esta promoção do app?", options)
        .then(res => {
          if (res.ok == true) {
            axios
              .delete(`${config.default.servidor}/gerencial/promocao/${id}`, {
                headers: {
                  Authorization: "Basic c2E6QURNQUNDRVNZUw=="
                }
              })
              .then(response => {
                if (response.status == 200) {
                  const options = { title: "Aviso", size: "sm" };
                  this.$dialogs
                    .alert("A promoção foi desvinculada com sucesso.", options)
                    .then(res2 => {});
                  this.procurarPromocoes();
                }
              })
              .error(error => {
                alert(error);
              });
          }
        });
    },
    procurarPromocoes() {
      this.isLoading = true;
      axios
        .get(
          `${
            config.default.servidor
          }/gerencial/promocao/ativa/${localStorage
            .getItem("enterprise_id")
            .toString()}/${localStorage.getItem("app_version")}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          console.log(response.data.data);
          if (response.data.data.length > 0) {
            this.items = response.data.data;
            this.numPromocoes = this.items.length;
            this.haveItems = true;
          } else {
            this.haveItems = false;
          }
          this.isLoading = false;
          // console.log(response.data.data);
        })
        .catch(error => {
          console.error(error);
        });
    },
    editarPromocao(id) {
      this.$router.push({ path: `promocoes/editar-promocao/${id}` });
    },
    limpaLocalStorage() {
      localStorage.removeItem("jornalzinho");
      localStorage.removeItem("selecionado");
      localStorage.removeItem("titulo");
      localStorage.removeItem("descricao");
      localStorage.removeItem("data_inicial");
      localStorage.removeItem("data_final");
      localStorage.removeItem("image");
      localStorage.removeItem("have-push");
      localStorage.removeItem("promocaoSelecionada");
    }
  },
  beforeMount() {
    this.limpaLocalStorage();
    this.IsJornalzinho = true;
    this.procurarPromocoes();
  }
};
</script>


